<template>
	<div>
		<v-dialog v-model="dialog.flag" width="450" >
			<v-card class="pb-8">
				<p class="text-right pr-3" style="margin-bottom:-10px !important">
					<v-icon color="#8F8F8F" small
					@click="dialog.flag=false">
					mdi-window-close
				</v-icon>
			</p>
			<v-card-title class="headline flex-column title-text" primary-title >
				<p class="page-title text-center">{{$lang.ADD_A_RETAILER.toUpperCase()}}</p>
			</v-card-title >
			<v-card-text class="flex-column text-center">
				<v-row>
					<v-col cols="6" md="6" class="text-center">
						<img src="@/assets/add-retailer.svg" class="cursor-pointer" alt="" @click="addNewRetailer()">
						<p class="sub-title-text-2 fs-14">{{$lang.ADD_NEW_RETAILER}}</p>
					</v-col>
					<v-col cols="6" md="6" class="text-center cursor-pointer">
						<img src="@/assets/list.svg" alt="" @click="selectfromExisting">
						<p class="sub-title-text-2 fs-14">{{$lang.SELECT_FROM_EXISTING_LIST}}</p>
					</v-col>
				</v-row>
			</v-card-text>
		</v-card>
	</v-dialog>
</div>
</template>
<script>
export default{
	props:['dialog'],
	methods:{
		addNewRetailer(){
			this.dialog.flag=false
			this.$router.push({name:'add-retailer'})
		},
		selectfromExisting(){
			this.dialog.flag=false
			this.$emit('handle-response')
		}
	}
}

</script>